export class MatchVideo {
  static readonly embedBase = 'https://www.youtube.com/embed/';
  static readonly watchBase = 'https://www.youtube.com/watch?v=';
  static readonly shortURLBase = 'https://youtu.be/';

  livestreamURL: string;
  highlightsURL: string;
  tickerURL: string;

  // TODO create video service and move static functions there?
  static makeEmbedURL(url) {
     url = url.replace(this.shortURLBase, this.watchBase);
     return url.replace('watch?v=', 'embed/');
  }

  static youtubePreviewImageURL(url: string) {
    const id = this.videoIDFromURL(url);
    return 'https://i3.ytimg.com/vi/' + id + '/mqdefault.jpg';
  }

  static videoIDFromURL(url: string) {
    const baseURLs = [this.embedBase, this.watchBase, this.shortURLBase];

    for (let baseURL of baseURLs) {
      if (url.indexOf(baseURL) !== -1) {
        return url.replace(baseURL, '');
      }
    }
  }

  public constructor(init?: Partial<MatchVideo>) {
    Object.assign(this, init);
  }
}
